import { SxProps, Theme } from "@mui/material";
import type { SystemStyleObject } from "@mui/system";
import { SIGNUP_COLORS, commonStyles } from "../../tokens";

export const inputSx: SxProps = {
  ...commonStyles.inputField,
  "& span": {
    "&[class*='makeStyles-label']": {
      color: `${SIGNUP_COLORS.primary} !important`,
      fontFamily: "Manrope !important",
      fontSize: "16px !important",
      fontWeight: "600 !important",
    },
  },
  "& .makeStyles-label-1, & .makeStyles-label-2, & .makeStyles-label-3, & .makeStyles-label-4, & .makeStyles-label-5, & .makeStyles-label-6, & .makeStyles-label-7, & .makeStyles-label-8, & .makeStyles-label-9, & .makeStyles-label-10": {
    color: `${SIGNUP_COLORS.primary} !important`,
  },
  "& .MuiFormControl-root span": {
    color: `${SIGNUP_COLORS.primary} !important`,
  },
};

export const selectSx: SxProps = {
  ...commonStyles.selectField,
  "& .MuiInputLabel-root": {
    fontSize: "16px",
    fontWeight: 500,
    mb: 1,
  },
};

export const backButtonSx: SxProps = commonStyles.secondaryButton;

export const nextButtonSx: SxProps = commonStyles.primaryButton;

export const gridItem = {
  mb: "24px",
} as SystemStyleObject<Theme>;

export const buttonRow = {
  mt: "24px",
} as SystemStyleObject<Theme>;